export default __webpack_public_path__ + "static/media/ARR Mascots-08.1796abbd.jpg";